import React from 'react'

import { Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { IPostElementProps } from '../../../../types/types'

const Headline: React.FC<IPostElementProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      display: 'inline-block',
      padding: props.view === 'overview' ? '' : '14px 0 0',
    },
  }))

  const classes = useStyles()

  return (
    <>
      {props.value && (<Typography className={classes.root} variant={props.view === 'preview' ? 'h5' : 'h4'}>{props.value}</Typography>)}
    </>
  )
}

export default Headline
